import { render } from "./dynamicTable.vue?vue&type=template&id=0ff75c02"
import script from "./dynamicTable.vue?vue&type=script&lang=js"
export * from "./dynamicTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/vab/table/dynamicTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ff75c02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ff75c02', __exports__)) {
    console.log('reload')
    api.reload('0ff75c02', __exports__)
  }
  
  module.hot.accept("./dynamicTable.vue?vue&type=template&id=0ff75c02", () => {
    console.log('re-render')
    api.rerender('0ff75c02', render)
  })

}


export default __exports__